import {createAsyncAction} from "./utils";

export const getCards = createAsyncAction('CARDS/GET_CARDS');

export const getById = createAsyncAction('CARDS/GET_BY_ID');
